import http from "../httpRequest";
import useGlobalState from "../../context/GlobalState";



class AuthService {
    async login(email: string, password: string) {
        let response = await http.post("/auth/login", { email, password });
        if (response?.status === 200) {
            useGlobalState.setState({ user: response.data, isLogged: true});
        }
        return response;
    }

    async logout() {
        let response = await http.post("/auth/logout");
        useGlobalState.setState({ user: undefined, isLogged: false });
        return response?.data;
    }

    async me() {
        let response = await http.get("/auth/me");
        return response?.data;
    }
}

export default new AuthService();